import { DocumentData, FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions, Timestamp } from "firebase/firestore";

export default interface Message {
  id: string;
  type?: "WEB" | "CHAT";
  time?: Date;
  fromTeamId?: string; // sender team ID
  fromTeamName?: string; // sender team name
  fromPlayerId?: string; // sender player ID
  fromPlayerName?: string; // sender player name
  fromInstructorId?: string; // sender user id
  fromInstructorName?: string; // sender user name
  text?: string; // chat message content
  privateTeamIds?: null | [string]; // recipient team IDs if private message, otherwise null
  privatePlayerIds?: null | [string]; // recipient player IDs if private message, otherwise null
}

export class MessageConverter implements FirestoreDataConverter<Message> {
  toFirestore(message: Message): DocumentData {
    return message;
  }

  fromFirestore(snapshot: QueryDocumentSnapshot<DocumentData>, options: SnapshotOptions): Message {
    return Object.freeze({ id: snapshot.id, ...snapshot.data(options) });
  }
}

// Time ago filter
export function timeAgo(timestamp: Timestamp) {
  const currentTimestamp = Timestamp.now();
  const ms = timestamp ? currentTimestamp.toMillis() - timestamp.toMillis() : 0;

  const s = Math.floor(ms / 1000);
  const m = Math.floor(s / 60);
  const h = Math.floor(s / 3600);
  const d = Math.floor(s / 86400);

  if (s < 20) {
    return "just now";
  } else if (s < 60) {
    return s + "s ago";
  } else if (s < 3600) {
    return m + "m ago";
  } else if (s < 86400) {
    return h + "h ago";
  } else {
    return d + " days ago";
  }
}
